import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const DashboardButton = ({ onToggle, isOpen }) => {
  // Use the transparent GIF
  const gifUrl = "/dashboard-logo-transparent.gif";
  
  return (
    <>
      {/* Mobile: Just GIF in button */}
      <button
        onClick={onToggle}
        className="sm:hidden flex items-center justify-center p-1.5 rounded-lg transition-all hover:bg-gray-50"
        style={{ 
          minWidth: '56px', 
          minHeight: '56px'
        }}
        title="Dashboard Menu"
      >
        <img 
          src={gifUrl}
          alt="Dashboard"
          className="w-12 h-12"
          style={{ objectFit: 'contain' }}
        />
      </button>

      {/* Tablet/Laptop: GIF + "Dash" + Arrow */}
      <button
        onClick={onToggle}
        className="hidden sm:flex lg:hidden items-center gap-2 px-3 py-2 rounded-lg transition-all hover:bg-gray-50"
        title="Dashboard Menu"
      >
        <img 
          src={gifUrl}
          alt="Dashboard"
          className="w-12 h-12"
          style={{ objectFit: 'contain' }}
        />
        <span className="font-semibold text-base" style={{ color: '#1d1d1b' }}>Dash</span>
        {isOpen ? (
          <ChevronUp className="w-5 h-5" style={{ color: '#ee7203' }} />
        ) : (
          <ChevronDown className="w-5 h-5" style={{ color: '#ee7203' }} />
        )}
      </button>

      {/* Desktop: GIF + "Dashboard" + Arrow */}
      <button
        onClick={onToggle}
        className="hidden lg:flex items-center gap-2 px-4 py-2 rounded-lg transition-all hover:bg-gray-50"
        title="Dashboard Menu"
      >
        <img 
          src={gifUrl}
          alt="Dashboard"
          className="w-14 h-14"
          style={{ objectFit: 'contain' }}
        />
        <span className="font-semibold text-lg" style={{ color: '#1d1d1b' }}>Dashboard</span>
        {isOpen ? (
          <ChevronUp className="w-5 h-5" style={{ color: '#ee7203' }} />
        ) : (
          <ChevronDown className="w-5 h-5" style={{ color: '#ee7203' }} />
        )}
      </button>
    </>
  );
};

export default DashboardButton;
